import { Navigate } from "react-router-dom";

const PrivateRoute = ({ isAuthenticated, element, list }) => {
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return element;
};
export default PrivateRoute;
